export const getProductTabFromSearch = search => {
  if (!search) return null;

  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const tabParam = params.get('tab');

  return tabParam || null;
};

export const getDefaultProductTab = ({
  hasDescription = false,
  hasRelatedProducts = false,
  hasAnalogProducts = false,
  hasAnalogCodes = false,
  hasReceiving = true,
  hasReviews = false,
  hasQuestions = false,
  hasPackagingParameters = false,
} = {}) => {
  if (hasDescription) return 'description';
  if (hasRelatedProducts) return 'related-products';
  if (hasAnalogProducts) return 'analog-products';
  if (hasAnalogCodes) return 'analog-codes';
  if (hasReceiving) return 'receiving';
  if (hasReviews) return 'reviews';
  if (hasQuestions) return 'questions';
  if (hasPackagingParameters) return 'packaging-parameters';

  return 'receiving';
};
